/**
 *
 * Mixin utile per 'trasformare' un form in un 'wizard' aggiungendo una toolbar di navigazione e gli opportuni metodi di gestione.
 * Necessita di avere un form con determinate caratteristiche.
 * Tipicamente usato in una dialog, ma potrebbe anche essere usato in dashlet (cui si deve però prestare attenzione visto che ha dimensioni statiche a differenza delle dialog)
 *
 */
hrd.manager.WizardLikeFormMixin = hrd.AbstractMixin.extend({
	wizardCursor: 0,
	init: function(ref, options){
		var defaults = {
			impl: 'hrd.manager.WizardLikeFormMixin',
		};
		let wizard = {wizard: options};
		let settings = $.extend({}, defaults, wizard);
		this._super(ref, settings);
	},
	defaultSettings: function() {
		// save: never/end/always/hidden; cancel: never/always/end; nav: always/hidden/never
		return {
			cancel: 'always',
			save: 'hidden',
			nav: 'always',
			titleSuffix: '',
			header: false,
			lazy: false
		};
	},
	doInitializeMixin: function(settings) {
		// devo recuperare il 'contenitore' in modo diverso se si tratta di dashlet o dialog
		let $container = (this.panel && this.panel.exists()) ? this.panel : (typeof this.getDialog === 'function') ? this.getDialog() : $('none');
		let widardFieldset = $container.find('.fieldset[data-wizard]');
		if(widardFieldset.exists()) {
			let wizardInfo = $.evaluate(widardFieldset.data('wizard'), this);
			wizardInfo = $.extend(this.defaultSettings(), wizardInfo);
			widardFieldset.data('wizardInfo', wizardInfo);
			widardFieldset.addClass('wizard-fieldset');
			if(settings.wizard.minHeight != undefined) {
				widardFieldset.css({
					minHeight: settings.wizard.minHeight + 'px'
				})
			}

			/* creo HTML specifico per i vari pulsanti */
			let prev =
				!$('[data-action="wizardPrevAction"]', $container).exists()
					? $(`<button data-action="wizardPrevAction"   data-ignore-activate-on-return="true" data-width="120" data-show-text="true" data-icon-primary="fas fa-chevron-left"  data-keep-dialog-opened="true" data-reverse="true">Indietro</button>`)
					: '';

			let next =
				!$('[data-action="wizardNextAction"]', $container).exists()
					? $(`<button data-action="wizardNextAction"   data-ignore-activate-on-return="true" data-width="120" data-show-text="true" data-icon-secondary="fas fa-chevron-right" data-keep-dialog-opened="true" data-validation="true" data-reverse="true">Avanti</button>`)
					: '';

			let save =
				!$('[data-action="wizardSaveAction"]', $container).exists()
					? $(`<button data-action="wizardSaveAction"   data-show-text="true"  data-validation="true" data-icon-primary="far fa-save" data-toggle-only-me="true">Salva</button>`)
					: '';

			let canc =
				!$('[data-action="wizardCancelAction"]', $container).exists()
					? $(`<button data-action="wizardCancelAction" data-show-text="true">Annulla</button>`)
					: '';

			let navigator = `
				<div class="fieldset wizard-navigation-bar bottom-fieldset">
					<div class="field-composite right-align field-composite-2x">
						<span class="wizard-nav-elements">
							${prev && prev.prop('outerHTML')}
							${next && next.prop('outerHTML')}
						</span>
						${save && save.prop('outerHTML')}
						${wizardInfo.cancel === 'always' ? canc && canc.prop('outerHTML') : ''}
					</div>
				</div>
			`;

			$('[data-action="wizardPrevAction"]', $container)
				.attr('data-ignore-activate-on-return', true)
				.attr('data-keep-dialog-opened', true);

			$('[data-action="wizardNextAction"]', $container)
				.attr('data-ignore-activate-on-return', true)
				.attr('data-keep-dialog-opened', true)
				.attr('data-validation', $('[data-action="wizardNextAction"]', $container).attr('data-validation') || true);

			$('[data-action="wizardSaveAction"]', $container)
				.attr('data-ignore-activate-on-return', true)
				.attr('data-keep-dialog-opened', true)
				.attr('data-validation', true);

			$('[data-action="wizardCancelAction"]', $container)
				.attr('data-ignore-activate-on-return', true)
				.attr('data-keep-dialog-opened', true);

			if(wizardInfo.nav !== 'never') {
				widardFieldset.after(navigator);
			}

			$container.find('.wizard-nav-elements').css({
				position: 'absolute',
				left: '50%',
				transform: 'translate(-50%, 0)'
			});
		} else {
			$.timeout(0).then(() =>  {
				console.log(`Cannot use wizard capabilities because 'data-wizard' is missing in ${$container.attr('id')}`);
			})
		}
	},
	mixinFormEnhanced: function(formInstance) {
		const wizardInfo = $('.wizard-fieldset', formInstance.container).data('wizardInfo');
		this.toolbox = this.toolbox || new hrd.Toolbox(); // if it exists, no need to reinitialize it
		this.startWizard(formInstance);
		
		// Add a class to the dialog if wizard is its child, and if is a dialog
		let $dialog = (typeof this.getDialog === 'function') ? this.getDialog() : $('none');
		if($dialog.exists()) {
			$dialog.dialog('option', 'addDialogClass', 'dialog--with-wizard');
		}

		// Hide dialog header if chosen in the data-wizard
		if(wizardInfo.header) {
			let requestedHeight = $dialog.dialog('option', 'height');
			$(formInstance.container).closest('.ui-dialog').find('.ui-dialog-titlebar').hide();
			if(requestedHeight != undefined) {
				$dialog.dialog('option', 'height', requestedHeight);
			}
		}
		this.wizardStarted();
	},
	wizardStarted: $.noop,
	/**
	 * method needed for restoring all blocks visibility to 'block' when the dialog is closed.
	 * This is needed for future re-opening of the dialog in 'label' width computation
	 */
	onCloseDialog: function(formInstance, dialogId) {
		formInstance.$form.find('.fieldset[data-wizard-block]').each((i, block) => {
			$(block).css('display', 'block');
		});
		this.onCloseDialogCustom(formInstance, dialogId);
	},
	onCloseDialogCustom: $.noop,
	startWizard: function(formInstance) {
		const toolbox = new hrd.Toolbox();
		const wizardInfo = $('.wizard-fieldset', formInstance.container).data('wizardInfo');
		
		let wizardFieldset = formInstance.$container.find('.wizard-fieldset');
		let blocks = wizardFieldset.find('.fieldset[data-wizard-block]');
		
		// store blocks definitions in 'wizardFieldset', for future use in goto function
		let wizardBlocks = blocks.toArray().reduce((obj, block, index) => {
			let blockInfo = $.evaluate($(block).data('wizardBlock'), this);
			blockInfo.index = index;
			obj[blockInfo.block] = blockInfo;
			return obj;
		}, {});
		wizardFieldset.data('wizard-blocks-info', wizardBlocks);
		
		const closeWhenPromise = toolbox.get('splashScreenOptions.closeWhen', dashboardInstance, $.when());
		closeWhenPromise
			.always(() => {
				if(!wizardInfo.lazy) {
					this.wizardCursor = 0; // force to zero because is starting
					this.moveWizard(formInstance.toObject(), formInstance);
				}
				const showAction = this.__trigger__('wizardStarted', formInstance.toObject(), formInstance);
			});
	},
	moveWizard: function(formData, formInstance) {
		let wizardFieldset = formInstance.$container.find('.wizard-fieldset');
		let wizardInfo = wizardFieldset.data('wizardInfo');
		let blocks = wizardFieldset.find('.fieldset[data-wizard-block]');
		this.wizardCursor = Math.max(0, Math.min(blocks.length - 1, this.wizardCursor));
		blocks.each((index, block) => {
			let showBlock = (index === this.wizardCursor);

			if($(block).closest('.chroma-flow').exists()) {
				if(showBlock) {
					$(block).css({
						'display': 'flex',
						'flex-direction': 'column'
					});
				} else {
					$(block).hide();
				}	
			} else {
				$(block).toggle(showBlock);
			}
		});
		let contentHeight = wizardFieldset.height();
		blocks.each((index, block) => {
			if($(block).is(':visible')){
				$(block).css({minHeight: contentHeight});
			}
		});
		this.wizardButtonVisibility(formInstance);
		let context = this.__context__(formInstance);

		if(wizardInfo.header) {
			const context = this.__context__(formInstance);
			const wizardTitle = context.title;
			const wizardCurrentCount = this.wizardCursor + 1;
			const wizardMaxCount = blocks.length;

			$('[data-wizard-title]', wizardFieldset.closest('.hrd-form')).html(wizardTitle);
			$('[data-wizard-count]', wizardFieldset.closest('.hrd-form')).html(`Passaggio ${wizardCurrentCount} di ${wizardMaxCount}`);
		} else {
			let titleSuffix = wizardInfo.titleSuffix || ' (${count}/${total})'; // variabili: title, count, total
			titleSuffix = titleSuffix.replaceAll('%{', '${');

			let wizardTitle = this.toolbox.toTemplate(titleSuffix, {title: context.title, count: this.wizardCursor + 1, total: blocks.length});
			this.appendTitle(wizardTitle);
		}

		let showAction = this.__trigger__('showBlock', formData, formInstance);
	},
	wizardButtonVisibility: function(formInstance) {
		let wizardFieldset = formInstance.$container.find('.wizard-fieldset');
		let wizardInfo = wizardFieldset.data('wizardInfo');
		let blocks = wizardFieldset.find('.fieldset[data-wizard-block]');
		formInstance.toggleEnablementButton('wizardPrevAction', this.wizardCursor !== 0);
		formInstance.toggleEnablementButton('wizardNextAction', this.wizardCursor !== (blocks.length - 1));

		if(wizardInfo.nav === 'hidden') {
			formInstance.getButton('wizardPrevAction').css('visibility', (this.wizardCursor !== 0) ? 'visible' : 'hidden');
			formInstance.getButton('wizardNextAction').css('visibility', (this.wizardCursor !== (blocks.length - 1)) ? 'visible' : 'hidden');
		}
		
		if(wizardInfo.save === 'never') {
			formInstance.toggleButton('wizardSaveAction', false);
		} else if(wizardInfo.save === 'hidden') {
			formInstance.toggleButton('wizardSaveAction', this.wizardCursor === (blocks.length - 1));
		} else {
			formInstance.toggleEnablementButton('wizardSaveAction', this.wizardCursor === (blocks.length - 1));
		}
	},
	wizardPrevAction: function(event, formData, formInstance) {
		var deferred = $.Deferred();
		let beforeAction = this.__trigger__('beforePrev', formData, formInstance);
		beforeAction.then(response => {
			if(response === true) {
				this.wizardCursor = this.wizardCursor - 1;
				this.moveWizard(formData, formInstance);
				let afterAction = this.__trigger__('afterPrev', formData, formInstance);
				afterAction.then(response => {
					deferred.resolve();
				});
			} else {
				this.wizardButtonVisibility(formInstance);
				deferred.resolve();
			}
		});
		return deferred.promise();
	},
	wizardNextAction: function(event, formData, formInstance) {
		var deferred = $.Deferred();
		let beforeAction = this.__trigger__('beforeNext', formData, formInstance);
		beforeAction.then(response => {
			if(response.stop !== true) {
				formData = response.formData || formData,
				this.wizardCursor = this.wizardCursor + 1;
				this.moveWizard(formData, formInstance);
				let afterAction = this.__trigger__('afterNext', formData, formInstance);
				afterAction.then(response => {
					deferred.resolve();
				});
			} else {
				this.wizardButtonVisibility(formInstance);
				deferred.resolve();
			}
		});
		return deferred.promise();
	},
	wizardGoTo: function(cursorOrStep) {
		let formInstance = this.formInstance || this.getFormInstance();
		let cursor = 0;
		if(typeof cursorOrStep === 'number') {
			cursor = cursorOrStep;
		} else {
			let wizardFieldset = formInstance.$container.find('.wizard-fieldset');
			let wizardBlocks = wizardFieldset.data('wizard-blocks-info');
			let block = wizardBlocks[cursorOrStep];
			if(block != undefined) {
				cursor = block.index;
			}
		}
		let formData = formInstance.toObject();
		var deferred = $.Deferred();
		let beforeAction = this.__trigger__('beforeGoTo', formData, formInstance);
		beforeAction.then(response => {
			if(response.stop !== true) {
				formData = response.formData || formData,
				this.wizardCursor = cursor;
				this.moveWizard(formData, formInstance);
				let afterAction = this.__trigger__('afterGoTo', formData, formInstance);
				afterAction.then(response => {
					deferred.resolve();
				});
			} else {
				this.wizardButtonVisibility(formInstance);
				deferred.resolve();
			}
		});
		return deferred.promise();
	},
	wizardSaveAction: function(event, formData, formInstance) {
		this.closeDialog(true, false);
	},
	wizardCancelAction: function(event, formData, formInstance) {
		this.closeDialog(false, true);
	},
	__context__: function(formInstance) {
		let wizardFieldset = formInstance.$container.find('.wizard-fieldset');
		let blocks = wizardFieldset.find('.fieldset[data-wizard-block]');
		this.wizardCursor = Math.max(0, Math.min(blocks.length - 1, this.wizardCursor));
		let currentBlock = $(blocks.get(this.wizardCursor));
		let blockContext = currentBlock.data('wizardBlockInfo');
		if(blockContext == undefined) {
			blockContext = $.evaluate(currentBlock.data('wizardBlock'), this);
			currentBlock.data('wizardBlockInfo', blockContext);
		}
		return {id: this.wizardCursor, block: blockContext.block, title:blockContext.title, container: currentBlock};
	},
	__trigger__: function(event, formData, formInstance) {
		let response;
		let context = this.__context__(formInstance);
		let eventFn = $.functionCase(`on-${event}`);
		if(typeof this[eventFn] === 'function'){
			response = this[eventFn].call(this, context, formData, formInstance);
		}
		return response == undefined ? $.when(true) : $.when(response);
	}
});